"use client"

import { Button } from "@heroui/react"
import { useRouter } from "next/navigation";

export interface BoxedCTAProps {
  description?: string,
  btn_text: string,
  btn_link: string,
  backgroundColor?: string,
  textColor?: string,
  title?: string,
}

const BoxedCTA = ({ description, btn_text, backgroundColor = '#9A896C', textColor = '#ffff', btn_link = '#', title }: BoxedCTAProps) => {

  const router = useRouter();

  return (
    <>
      <div className={`rounded-[9.52px] md:rounded-full py-3.5 md:py-5 px-[16.32px] md:px-6 flex flex-col md:flex-row justify-between items-center flex-nowrap gap-y-2`} style={{ backgroundColor: backgroundColor, color: textColor }}>
        <div className="space-y-2">
          {(title && title?.trim()?.length) ? <p className={`font-semibold text-base md:text-lg px-2 md:px-4 text-center md:text-start`}>{title}</p> : <></>}
          {(description && description?.trim()?.length) ? <p className={`font-semibold text-base md:text-lg px-2 md:px-4 text-center md:text-start`}>{description}</p> : <></>}
        </div>
        <div className="flex justify-end items-center flex-1">
          <Button className="btn_responsive_cta silverblue_btn mx-auto" onPress={() => router.push(btn_link)}>{btn_text}</Button>
        </div>
      </div>
    </>
  )
}

export default BoxedCTA
